const DAP_URL = process.env.REACT_APP_DAP_URL;
const TASK_MANAGEMENT_URL = process.env.REACT_APP_TASK_MANAGEMENT;
const CERO_CMS_URL = process.env.REACT_APP_CERO_CMS_URL;
const GOOGlE_API_KEY = process.env.REACT_APP_GOOGlE_API_KEY;
const GOOGLE_CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const PAT_URL = process.env.REACT_APP_PAT_URL;

const MICROSOFT_APP_ID = process.env.REACT_APP_MICROSOFT_APP_ID;
const MICROSOFT_DIR_ID = process.env.REACT_APP_MICROSOFT_DIR_ID;
const MICROSOFT_AUTHORITY = `https://login.microsoftonline.com/common`;
const MICROSOFT_SCOPE = ["User.Read"];
const BACKGROUND_VIDEO = process.env.REACT_APP_LOGIN_BACKGROUND_VIDEO;
const ENV_TYPE = process.env.REACT_APP_ENV_TYPE;
const PLATFORM_LOGO = `/platform/platform_logo.png`;
const SHOW_PLATFORM_LOGO = false;
const SKIP_SITE_SELECTION = true;
const DISABLE_REGISTRATION = false;


//for dev server
let API_URL = `${process.env.REACT_APP_API_URL}/api`; //backend api url
let WEB_URL = process.env.REACT_APP_URL; //frontend url

if (ENV_TYPE === "dev") {
  API_URL = `/api`;
  WEB_URL = "http://localhost:3000";
}

const MICROSOFT_POPUP_REDIRECT = WEB_URL + "blank.html";

const DEMP_FEATURES = {
  DAP: "DP",
  DEVICE: "DI",
  EVENT: "ET",
  CMS: "CM",
  PAT: "PT",
  DEMP: "DM",
  MAP: "MP",
  SETTING: "ST",
  TASK_MANAGEMENT: "TK",
  DATA_SOURCE: "DS",
  HEADER: {
    DASHBOARD: "DB",
    EVENT: "EV",
    ANALYTIC: "AN",
    REPORT_EN: "RP_EN",
    REPORT_EV: "RP_EV",
    ESG: "OT",
  },
};

export {
  SKIP_SITE_SELECTION,
  DEMP_FEATURES,
  PAT_URL,
  BACKGROUND_VIDEO,
  API_URL,
  GOOGlE_API_KEY,
  GOOGLE_CLIENT_ID,
  // DOMAIN_URL,
  DAP_URL,
  TASK_MANAGEMENT_URL,
  WEB_URL,
  MICROSOFT_APP_ID,
  MICROSOFT_DIR_ID,
  MICROSOFT_AUTHORITY,
  MICROSOFT_POPUP_REDIRECT,
  MICROSOFT_SCOPE,
  ENV_TYPE,
  CERO_CMS_URL,
  PLATFORM_LOGO,
  SHOW_PLATFORM_LOGO,
  DISABLE_REGISTRATION
};
